import { useContext } from 'react';

import { MobileSignFormContext } from './context';

export const useMobileSignFormValues = () => {
	const context = useContext(MobileSignFormContext);
	if (!context) {
		throw new Error('MobileSignFormContext not found');
	}
	return context;
};
